// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_WEAR_PARTS
        });

        dispatch(routerActions.replace('/claims/wear-parts/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/copy-claim.js